import { Pipe, PipeTransform } from '@angular/core';
import { BatchLog } from '../models/batchLog';
import { ImageFile } from '../models/imageFile';

@Pipe({
  name: 'imageTypeToBatch'
})
export class ImageTypeToBatchPipe implements PipeTransform {

  transform(batches: BatchLog[], imageTypeIdFilter?: number): any[] {
    if (!batches || !imageTypeIdFilter) { return batches; }
    return batches.filter(a => a.imageTypeId === imageTypeIdFilter);
  }
}

@Pipe({
  name: 'imageTypeGroup'
})
export class ImageTypeGroupPipe implements PipeTransform {

  transform(records: ImageFile[], typeId: number) {
    if (!records || !typeId) { return records; }
    return records.filter(a => a.typeOfImageId === +typeId);
  }
}
